import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_flight_summary_results';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/CheckoutFlightSummaryResults')), {
  delay: 500
});